import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  inject,
  Renderer2,
  type OnDestroy,
  type OnInit,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { Router, RouterModule } from '@angular/router'
import { credits, currentYear } from '@common/constants';
import { MapComponent } from '@components/map/map.component';
import { SelectFormInputDirective } from '@core/directive/select-form-input.directive';
import { AlertService } from '@core/services/alert.service';
import { WaktuSolatService } from '@core/services/waktu-solat.service';
import { environment } from '@environment/environment';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { interval, Observable, Subscriber, Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-landing-page-layout',
  standalone: true,
  imports: [RouterModule, NgbCarouselModule, FormsModule, ReactiveFormsModule, MapComponent],
  templateUrl: './landing-page-layout.component.html',
  styleUrls: ['./landing-page-layout.component.scss']
})
export class LandingPageLayoutComponent implements OnInit, OnDestroy {
  currentYear = currentYear
  // credits = credits

  waktuSolat: any;
  prayerTime: any;
  tarikh_masihi: any;
  tarikh_hijri: any;
  negeri: any;
  code: any;
  zon!: string;
  state: any;
  zon_solat: any;
  private renderer = inject(Renderer2)
  public fb = inject(UntypedFormBuilder)
  public waktu = inject(WaktuSolatService)
  public _detector = inject(ChangeDetectorRef)
  public http = inject(HttpClient)
  public router = inject(Router)
  alert = inject(AlertService)

  curr_date = new Date();
  pengumumans: any;
  announcements: any = [];
  baseUrl = environment.baseUrl;

  reactiveForm = this.fb.group({
    zon: [''],
  });
  loading: boolean = false;

  locationList = [
    { code: "SGR01", zone: "SGR01 - Gombak, Petaling, Sepang, Hulu Langat, Hulu Selangor, S.Alam" },
    { code: "SGR02", zone: "SGR02 - Kuala Selangor, Sabak Bernam" },
    { code: "SGR03", zone: "SGR03 - Klang, Kuala Langat" },
    { code: "JHR01", zone: "JHR01 - Pulau Aur dan Pulau Pemanggil" },
    { code: "JHR02", zone: "JHR02 - Johor Bahru, Kota Tinggi, Mersing, Kulai" },
    { code: "JHR03", zone: "JHR03 - Kluang, Pontian" },
    { code: "JHR04", zone: "JHR04 - Batu Pahat, Muar, Segamat, Gemas Johor, Tangkak" },
    { code: "KDH01", zone: "KDH01 - Kota Setar, Kubang Pasu, Pokok Sena (Daerah Kecil)" },
    { code: "KDH02", zone: "KDH02 - Kuala Muda, Yan, Pendang" },
    { code: "KDH03", zone: "KDH03 - Padang Terap, Sik" },
    { code: "KDH04", zone: "KDH04 - Baling" },
    { code: "KDH05", zone: "KDH05 - Bandar Baharu, Kulim" },
    { code: "KDH06", zone: "KDH06 - Langkawi" },
    { code: "KDH07", zone: "KDH07 - Puncak Gunung Jerai" },
    { code: "KTN01", zone: "KTN01 - Bachok, Kota Bharu, Machang, Pasir Mas, Pasir Puteh, Tanah Merah, Tumpat, Kuala Krai, Mukim Chiku" },
    { code: "KTN02", zone: "KTN02 - Gua Musang (Daerah Galas Dan Bertam), Jeli, Jajahan Kecil Lojing" },
    { code: "MLK01", zone: "MLK01 - SELURUH NEGERI MELAKA" },
    { code: "NGS01", zone: "NGS01 - Tampin, Jempol" },
    { code: "NGS02", zone: "NGS02 - Jelebu, Kuala Pilah, Rembau" },
    { code: "NGS03", zone: "NGS03 - Port Dickson, Seremban" },
    { code: "PHG01", zone: "PHG01 - Pulau Tioman" },
    { code: "PHG02", zone: "PHG02 - Kuantan, Pekan, Rompin, Muadzam Shah" },
    { code: "PHG03", zone: "PHG03 - Jerantut, Temerloh, Maran, Bera, Chenor, Jengka" },
    { code: "PHG04", zone: "PHG04 - Bentong, Lipis, Raub" },
    { code: "PHG05", zone: "PHG05 - Genting Sempah, Janda Baik, Bukit Tinggi" },
    { code: "PHG06", zone: "PHG06 - Cameron Highlands, Genting Higlands, Bukit Fraser" },
    { code: "PLS01", zone: "PLS01 - Kangar, Padang Besar, Arau" },
    { code: "PNG01", zone: "PNG01 - Seluruh Negeri Pulau Pinang" },
    { code: "PRK01", zone: "PRK01 - Tapah, Slim River, Tanjung Malim" },
    { code: "PRK02", zone: "PRK02 - Kuala Kangsar, Sg. Siput , Ipoh, Batu Gajah, Kampar" },
    { code: "PRK03", zone: "PRK03 - Lenggong, Pengkalan Hulu, Grik" },
    { code: "PRK04", zone: "PRK04 - Temengor, Belum" },
    { code: "PRK05", zone: "PRK05 - Kg Gajah, Teluk Intan, Bagan Datuk, Seri Iskandar, Beruas, Parit, Lumut, Sitiawan, Pulau Pangkor" },
    { code: "PRK06", zone: "PRK06 - Selama, Taiping, Bagan Serai, Parit Buntar" },
    { code: "PRK07", zone: "PRK07 - Bukit Larut" },
    { code: "SBH01", zone: "SBH01 - Bahagian Sandakan (Timur), Bukit Garam, Semawang, Temanggong, Tambisan, Bandar Sandakan, Sukau" },
    { code: "SBH02", zone: "SBH02 - Beluran, Telupid, Pinangah, Terusan, Kuamut, Bahagian Sandakan (Barat)" },
    { code: "SBH03", zone: "SBH03 - Lahad Datu, Silabukan, Kunak, Sahabat, Semporna, Tungku, Bahagian Tawau (Timur)" },
    { code: "SBH04", zone: "SBH04 - Bandar Tawau, Balong, Merotai, Kalabakan, Bahagian Tawau (Barat)" },
    { code: "SBH05", zone: "SBH05 - Kudat, Kota Marudu, Pitas, Pulau Banggi, Bahagian Kudat" },
    { code: "SBH06", zone: "SBH06 - Gunung Kinabalu" },
    { code: "SBH07", zone: "SBH07 - Kota Kinabalu, Ranau, Kota Belud, Tuaran, Penampang, Papar, Putatan, Bahagian Pantai Barat" },
    { code: "SBH08", zone: "SBH08 - Pensiangan, Keningau, Tambunan, Nabawan, Bahagian Pendalaman (Atas)" },
    { code: "SBH09", zone: "SBH09 - Beaufort, Kuala Penyu, Sipitang, Tenom, Long Pasia, Membakut, Weston, Bahagian Pendalaman (Bawah)" },
    { code: "SWK01", zone: "SWK01 - Limbang, Lawas, Sundar, Trusan" },
    { code: "SWK02", zone: "SWK02 - Miri, Niah, Bekenu, Sibuti, Marudi" },
    { code: "SWK03", zone: "SWK03 - Pandan, Belaga, Suai, Tatau, Sebauh, Bintulu" },
    { code: "SWK04", zone: "SWK04 - Sibu, Mukah, Dalat, Song, Igan, Oya, Balingian, Kanowit, Kapit" },
    { code: "SWK05", zone: "SWK05 - Sarikei, Matu, Julau, Rajang, Daro, Bintangor, Belawai" },
    { code: "SWK06", zone: "SWK06 - Lubok Antu, Sri Aman, Roban, Debak, Kabong, Lingga, Engkelili, Betong, Spaoh, Pusa, Saratok" },
    { code: "SWK07", zone: "SWK07 - Serian, Simunjan, Samarahan, Sebuyau, Meludam" },
    { code: "SWK08", zone: "SWK08 - Kuching, Bau, Lundu, Sematan" },
    { code: "SWK09", zone: "SWK09 - Zon Khas (Kampung Patarikan)" },
    { code: "TRG01", zone: "TRG01 - Kuala Terengganu, Marang, Kuala Nerus" },
    { code: "TRG02", zone: "TRG02 - Besut, Setiu" },
    { code: "TRG03", zone: "TRG03 - Hulu Terengganu" },
    { code: "TRG04", zone: "TRG04 - Dungun, Kemaman" },
    { code: "WLY01", zone: "WLY01 - Kuala Lumpur, Putrajaya" },
    { code: "WLY02", zone: "WLY02 - Labuan" }

  ]
  visitorCount: any;
  nextPrayer: string = '';
  countdown: string = '';
  private timerSubscription!: Subscription;
  ngOnInit(): void {
    this.renderer.addClass(document.body, 'h-100')
    this.http.get(this.baseUrl + `api/dashboard/visitor-count`).subscribe((res: any) => {
      // this.maisCard = res
      this.visitorCount = res
    })
    this.http.get(this.baseUrl + 'api/dashboard/list-pengumuman-carousel')
      .subscribe((resp: any) => {
        this.pengumumans = resp.filter((item: any) => item.status == 1);
        let announcements = resp.filter((item: any) => item.status == 1 && item.pengumuman != null);
        if (announcements) {
          this.announcements = announcements.map((item: any) => item.pengumuman ? item.pengumuman : '').join(' | ');
        }
        this._detector.markForCheck();
      });
    this.getCurrentPosition().subscribe((coordinate: any) => {
      //coordinate.latitude, coordinate.longitude
      this.waktu.getLocation(coordinate.latitude, coordinate.longitude).subscribe(response => {
        this.waktuSolat = response;
        // console.log('waktu solat', this.waktuSolat.data.code);

        this._detector.markForCheck();

        this.state = this.waktuSolat.data.attributes.jakim_code.substring(0, 3);
        console.log('negeri', this.state);

        if (this.state == 'sgr') {
          this.negeri = "Selangor";
          this.zon_solat = "SGR01 - Gombak, Petaling, Sepang, Hulu Langat, Hulu Selangor, S.Alam";
          this.code = 'SGR01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());
            this._detector.markForCheck();

          });
        } else if (this.state == 'jhr') {
          this.negeri = "Johor";
          this.zon_solat = "JHR01 - Pulau Aur dan Pulau Pemanggil";
          this.code = 'JHR01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'kdh') {
          this.negeri = "Kedah";
          this.zon_solat = "KDH01 - Kota Setar, Kubang Pasu, Pokok Sena (Daerah Kecil)";
          this.code = 'KDH01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'ktn') {
          this.negeri = "Kelantan";
          this.zon_solat = "KTN01 - Bachok, Kota Bharu, Machang, Pasir Mas, Pasir Puteh, Tanah Merah,Tumpat, Kuala Krai, Mukim Chiku";
          this.code = 'KTN01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'mlk') {
          this.negeri = "Melaka";
          this.zon_solat = "MLK01 - SELURUH NEGERI MELAKA";
          this.code = 'MLK01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'ngs') {
          this.negeri = "Negeri Sembilan";
          this.zon_solat = "NGS01 - Tampin, Jempol";
          this.code = 'NGS01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'phg') {
          this.negeri = "Pahang";
          this.zon_solat = "PHG01 - Pulau Tioman";
          this.code = 'PHG01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'png') {
          this.negeri = "Pulau Pinang";
          this.zon_solat = "PNG01 - Seluruh Negeri Pulau Pinang";
          this.code = 'PNG01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'prk') {
          this.negeri = "Perak";
          this.zon_solat = "PRK01 - Tapah, Slim River, Tanjung Malim";
          this.code = 'PRK01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'pls') {
          this.negeri = "Perlis";
          this.zon_solat = "PLS01 - Kangar, Padang Besar, Arau";
          this.code = 'PLS01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'sbh') {
          this.negeri = "Sabah";
          this.zon_solat = "SBH01 - Bahagian Sandakan (Timur), Bukit Garam, Semawang, Temanggong,Tambisan, Bandar Sandakan, Sukau";
          this.code = 'SBH01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'swk') {
          this.negeri = "Sarawak";
          this.zon_solat = "SWK01 - Limbang, Lawas, Sundar, Trusan";
          this.code = 'SWK01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'trg') {
          this.negeri = "Terengganu";
          this.zon_solat = "TRG01 - Kuala Terengganu, Marang, Kuala Nerus";
          this.code = 'TRG01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        } else if (this.state == 'wly') {
          this.negeri = "Wilayah Persekutuan";
          this.zon_solat = "WLY01 - Kuala Lumpur, Putrajaya";
          this.code = 'WLY01';
          this.waktu.getWaktuSolat(this.code).subscribe(res => {
            this.prayerTime = res.prayerTime[0];
            console.log('PrayerTime', this.prayerTime);
            this.updateNextPrayer();
            this.timerSubscription = interval(1000).subscribe(() => this.updateCountdown());

            this._detector.markForCheck();

          });
        }

        console.log(this.prayerTime);

        setTimeout(() => {

        }, 500);



        this.reorderLocationList(this.code)
        this.reactiveForm.patchValue({
          zon: this.code
        })
      });



    });

    this.waktu.getTarikhHijri(formatDate(new Date(), 'yyyy-MM-dd', 'en')).subscribe(response => {
      console.log(response);
      this.tarikh_masihi = response.tarikhMasihi;
      this.tarikh_hijri = response.tarikhHijri;

      this._detector.markForCheck();
    });


    this.tarikh_masihi = formatDate(new Date(), 'EEEE, MMMM d, y', 'en');
    this.tarikh_hijri = new Intl.DateTimeFormat('ar-TN-u-ca-islamic', { day: 'numeric', month: 'long', weekday: 'long', year: 'numeric' }).format(Date.now());


  }

  reorderLocationList(code: string) {
    const item = this.locationList.find(item => item.code === code);

    if (item) {
      this.locationList = [item, ...this.locationList.filter(item => item.code !== code)];
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'h-100')
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  checkMantainance() {
    this.loading = true
    return new Promise((resolve, reject) => {
      this.http.post(this.baseUrl + `api/system-setting/update-status`, {}).subscribe((res: any) => {
        // this.underMaintenance = res.data.under_maintenance
        this.loading = false
        
        if (res.data.under_maintenance == 1) {
          this.fireAlertWithImg();
          // this.fireAlertWithText();
        } else {
          this.router.navigate(['auth']);

        }

      })
    })
  }

  fireAlertWithImg(){
    Swal.fire({
      html: `<img src="assets/images/under_maintenance.jpg" 
        alt="Maintenance" 
        style="width:100%; height:100%; object-fit:cover;">`,
      background: 'rgba(255, 255, 255, 0)',
      width: '700px',
      allowOutsideClick: true,
      showCancelButton: false,
        showCloseButton: false,
      showConfirmButton: false,
    }).then((result) => {
      if (result.value) {
        // this.router.navigate(['auth']);

      }
    });
  }
  fireAlertWithText(){
    Swal.fire({
          text: "Kami sedang menjalankan penyelenggaraan untuk meningkatkan perkhidmatan kami. Harap maklum bahawa laman web ini buat sementara waktu tidak dapat diakses. Terima kasih atas kesabaran dan sokongan anda. Sila kembali semula nanti!",
          icon: "warning",
          showCancelButton: false,
          customClass: {
            confirmButton: 'btn btn-success me-2 mt-2',
          },
          confirmButtonText: "OK",
          showCloseButton: false,
          showConfirmButton: true,
          
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['auth']);

          }
        });
  }
  onSubmit() {

    console.log(this.reactiveForm.value.zon);
    this.waktu.getWaktuSolat(this.reactiveForm.value.zon).subscribe(res => {
      this.prayerTime = res.prayerTime[0];
      console.log(this.prayerTime);

      console.log('PrayerTime', this.prayerTime);
      this.updateNextPrayer();

      this._detector.markForCheck();

      //selangor
      if (this.reactiveForm.value.zon == 'SGR01') {
        this.zon_solat = "SGR01 - Gombak, Petaling, Sepang, Hulu Langat, Hulu Selangor, S.Alam";
      }
      if (this.reactiveForm.value.zon == 'SGR02') {
        this.zon_solat = "SGR02 - Kuala Selangor, Sabak Bernam";
      }
      if (this.reactiveForm.value.zon == 'SGR03') {
        this.zon_solat = "SGR03 - Klang, Kuala Langat";
      }
      // wilayah
      if (this.reactiveForm.value.zon == 'WLY01') {
        this.zon_solat = "WLY01 - Kuala Lumpur, Putrajaya";
      }
      if (this.reactiveForm.value.zon == 'WLY02') {
        this.zon_solat = "WLY02 - Labuan";
      }
      //johor
      if (this.reactiveForm.value.zon == 'JHR01') {
        this.zon_solat = "JHR01 - Pulau Aur dan Pulau Pemanggil";
      }
      if (this.reactiveForm.value.zon == 'JHR02') {
        this.zon_solat = "JHR02 - Johor Bahru, Kota Tinggi, Mersing, Kulai";
      }
      if (this.reactiveForm.value.zon == 'JHR03') {
        this.zon_solat = "JHR03 - Kluang, Pontian";
      }
      if (this.reactiveForm.value.zon == 'JHR04') {
        this.zon_solat = "JHR04 - Batu Pahat, Muar, Segamat, Gemas Johor, Tangkak";
      }
      //kedah
      if (this.reactiveForm.value.zon == 'KDH01') {
        this.zon_solat = "KDH01 - Kota Setar, Kubang Pasu, Pokok Sena (Daerah Kecil)";
      }
      if (this.reactiveForm.value.zon == 'KDH02') {
        this.zon_solat = "KDH02 - Kuala Muda, Yan, Pendang";
      }
      if (this.reactiveForm.value.zon == 'KDH03') {
        this.zon_solat = "KDH03 - Padang Terap, Sik";
      }
      if (this.reactiveForm.value.zon == 'KDH04') {
        this.zon_solat = "KDH04 - Baling";
      }
      if (this.reactiveForm.value.zon == 'KDH05') {
        this.zon_solat = "KDH05 - Bandar Baharu, Kulim";
      }
      if (this.reactiveForm.value.zon == 'KDH06') {
        this.zon_solat = "KDH06 - Langkawi";
      }
      if (this.reactiveForm.value.zon == 'KDH07') {
        this.zon_solat = "KDH07 - Puncak Gunung Jerai";
      }
      // kelantan
      if (this.reactiveForm.value.zon == 'KTN01') {
        this.zon_solat = "KTN01 - Bachok, Kota Bharu, Machang, Pasir Mas, Pasir Puteh, Tanah Merah,Tumpat, Kuala Krai, Mukim Chiku";
      }
      if (this.reactiveForm.value.zon == 'KTN02') {
        this.zon_solat = "KTN02 - Gua Musang (Daerah Galas Dan Bertam), Jeli, Jajahan Kecil Lojing";
      }
      // melaka
      if (this.reactiveForm.value.zon == 'MLK01') {
        this.zon_solat = "MLK01 - SELURUH NEGERI MELAKA";
      }
      // n9
      if (this.reactiveForm.value.zon == 'NGS01') {
        this.zon_solat = "NGS01 - Tampin, Jempol";
      }
      if (this.reactiveForm.value.zon == 'NGS02') {
        this.zon_solat = "NGS02 - Jelebu, Kuala Pilah, Rembau";
      }
      if (this.reactiveForm.value.zon == 'NGS03') {
        this.zon_solat = "NGS03 - Port Dickson, Seremban";
      }
      //pahang
      if (this.reactiveForm.value.zon == 'PHG01') {
        this.zon_solat = "PHG01 - Pulau Tioman";
      }
      if (this.reactiveForm.value.zon == 'PHG02') {
        this.zon_solat = "PHG02 - Kuantan, Pekan, Rompin, Muadzam Shah";
      }
      if (this.reactiveForm.value.zon == 'PHG03') {
        this.zon_solat = "PHG03 - Jerantut, Temerloh, Maran, Bera, Chenor, Jengka";
      }
      if (this.reactiveForm.value.zon == 'PHG04') {
        this.zon_solat = "PHG04 - Bentong, Lipis, Raub";
      }
      if (this.reactiveForm.value.zon == 'PHG05') {
        this.zon_solat = "PHG05 - Genting Sempah, Janda Baik, Bukit Tinggi";
      }
      if (this.reactiveForm.value.zon == 'PHG06') {
        this.zon_solat = "PHG06 - Cameron Highlands, Genting Higlands, Bukit Fraser";
      }
      //perlis
      if (this.reactiveForm.value.zon == 'PLS01') {
        this.zon_solat = "PLS01 - Kangar, Padang Besar, Arau";
      }
      //penang
      if (this.reactiveForm.value.zon == 'PNG01') {
        this.zon_solat = "PNG01 - Seluruh Negeri Pulau Pinang";
      }
      //perak
      if (this.reactiveForm.value.zon == 'PRK01') {
        this.zon_solat = "PRK01 - Tapah, Slim River, Tanjung Malim";
      }
      if (this.reactiveForm.value.zon == 'PRK02') {
        this.zon_solat = "PRK02 - Kuala Kangsar, Sg. Siput , Ipoh, Batu Gajah, Kampar";
      }
      if (this.reactiveForm.value.zon == 'PRK03') {
        this.zon_solat = "PRK03 - Lenggong, Pengkalan Hulu, Grik";
      }
      if (this.reactiveForm.value.zon == 'PRK04') {
        this.zon_solat = "PRK04 - Temengor, Belum";
      }
      if (this.reactiveForm.value.zon == 'PRK05') {
        this.zon_solat = "PRK05 - Kg Gajah, Teluk Intan, Bagan Datuk, Seri Iskandar, Beruas, Parit, Lumut, Sitiawan, Pulau Pangkor";
      }
      if (this.reactiveForm.value.zon == 'PRK06') {
        this.zon_solat = "PRK06 - Selama, Taiping, Bagan Serai, Parit Buntar";
      }
      if (this.reactiveForm.value.zon == 'PRK07') {
        this.zon_solat = "PRK07 - Bukit Larut";
      }
      //sabah
      if (this.reactiveForm.value.zon == 'SBH01') {
        this.zon_solat = "SBH01 - Bahagian Sandakan (Timur), Bukit Garam, Semawang, Temanggong, Tambisan, Bandar Sandakan, Sukau";
      }
      if (this.reactiveForm.value.zon == 'SBH02') {
        this.zon_solat = "SBH02 - Beluran, Telupid, Pinangah, Terusan, Kuamut, Bahagian Sandakan(Barat)";
      }
      if (this.reactiveForm.value.zon == 'SBH03') {
        this.zon_solat = "SBH03 - Lahad Datu, Silabukan, Kunak, Sahabat, Semporna, Tungku, Bahagian Tawau (Timur)";
      }
      if (this.reactiveForm.value.zon == 'SBH04') {
        this.zon_solat = "SBH04 - Bandar Tawau, Balong, Merotai, Kalabakan, Bahagian Tawau (Barat)";
      }
      if (this.reactiveForm.value.zon == 'SBH05') {
        this.zon_solat = "SBH05 - Kudat, Kota Marudu, Pitas, Pulau Banggi, Bahagian Kudat";
      }
      if (this.reactiveForm.value.zon == 'SBH06') {
        this.zon_solat = "SBH06 - Gunung Kinabalu";
      }
      if (this.reactiveForm.value.zon == 'SBH07') {
        this.zon_solat = "SBH07 - Kota Kinabalu, Ranau, Kota Belud, Tuaran, Penampang, Papar, Putatan, Bahagian Pantai Barat";
      }
      if (this.reactiveForm.value.zon == 'SBH08') {
        this.zon_solat = "SBH08 - Pensiangan, Keningau, Tambunan, Nabawan, Bahagian Pendalaman (Atas)";
      }
      if (this.reactiveForm.value.zon == 'SBH09') {
        this.zon_solat = "SBH09 - Beaufort, Kuala Penyu, Sipitang, Tenom, Long Pasia, Membakut, Weston, Bahagian Pendalaman (Bawah)";
      }
      //sarawak
      if (this.reactiveForm.value.zon == 'SWK01') {
        this.zon_solat = "SWK01 - Limbang, Lawas, Sundar, Trusan";
      }
      if (this.reactiveForm.value.zon == 'SWK02') {
        this.zon_solat = "SWK02 - Miri, Niah, Bekenu, Sibuti, Marudi";
      }
      if (this.reactiveForm.value.zon == 'SWK03') {
        this.zon_solat = "SWK03 - Pandan, Belaga, Suai, Tatau, Sebauh, Bintulu";
      }
      if (this.reactiveForm.value.zon == 'SWK04') {
        this.zon_solat = "SWK04 - Sibu, Mukah, Dalat, Song, Igan, Oya, Balingian, Kanowit, Kapit";
      }
      if (this.reactiveForm.value.zon == 'SWK05') {
        this.zon_solat = "SWK05 - Sarikei, Matu, Julau, Rajang, Daro, Bintangor, Belawai";
      }
      if (this.reactiveForm.value.zon == 'SWK06') {
        this.zon_solat = "SWK06 - Lubok Antu, Sri Aman, Roban, Debak, Kabong, Lingga, Engkelili, Betong, Spaoh, Pusa, Saratok";
      }
      if (this.reactiveForm.value.zon == 'SWK07') {
        this.zon_solat = "SWK07 - Serian, Simunjan, Samarahan, Sebuyau, Meludam";
      }
      if (this.reactiveForm.value.zon == 'SWK08') {
        this.zon_solat = "SWK08 - Kuching, Bau, Lundu, Sematan";
      }
      if (this.reactiveForm.value.zon == 'SWK09') {
        this.zon_solat = "SWK09 - Zon Khas (Kampung Patarikan)";
      }
      //terengganu
      if (this.reactiveForm.value.zon == 'TRG01') {
        this.zon_solat = "TRG01 - Kuala Terengganu, Marang, Kuala Nerus";
      }
      if (this.reactiveForm.value.zon == 'TRG02') {
        this.zon_solat = "TRG02 - Besut, Setiu";
      }
      if (this.reactiveForm.value.zon == 'TRG03') {
        this.zon_solat = "TRG03 - Hulu Terengganu";
      }
      if (this.reactiveForm.value.zon == 'TRG04') {
        this.zon_solat = "TRG04 - Dungun, Kemaman";
      }
    });
  }

  private getCurrentPosition(): any {
    return new Observable((observer: Subscriber<any>) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          observer.next({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          observer.complete();
        });
      } else {
        observer.error();
      }
    });
  }





  updateNextPrayer() {
    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const times: { [key: string]: Date } = {};

    for (const [prayer, time] of Object?.entries(this.prayerTime)) {
      if (prayer === 'date' || prayer === 'day' || prayer === 'hijri') continue;

      const prayerDate = new Date();
      const [hours, minutes, seconds] = (time as string).split(':').map(Number);
      prayerDate.setHours(hours, minutes, seconds, 0);
      times[prayer] = prayerDate;
    }

    const upcoming = Object.entries(times)
      .filter(([_, time]) => time > now)
      .sort((a, b) => a[1].getTime() - b[1].getTime())[0];

    if (upcoming) {
      this.nextPrayer = upcoming[0];
      if (this.nextPrayer == 'fajr') {
        this.nextPrayer = 'Subuh';
      }
      if (this.nextPrayer == 'dhuhr') {
        this.nextPrayer = 'Zohor';
      }
      if (this.nextPrayer == 'asr') {
        this.nextPrayer = 'Asar';
      }
      if (this.nextPrayer == 'maghrib') {
        this.nextPrayer = 'Maghrib';
      }
      if (this.nextPrayer == 'isha') {
        this.nextPrayer = 'Isyak';
      }
      this.updateCountdown(upcoming[1]);
    } else {
      // All prayers passed, default to tomorrow's fajr
      const fajrTime = this.prayerTime.fajr.split(':').map(Number);
      const nextDay = new Date();
      nextDay.setDate(now.getDate() + 1);
      nextDay.setHours(fajrTime[0], fajrTime[1], fajrTime[2], 0);
      this.nextPrayer = 'Fajr';
      this.updateCountdown(nextDay);
    }
  }

  updateCountdown(targetTime?: Date) {
    const now = new Date();
    const target = targetTime || this.getNextPrayerTime();
    const diff = target.getTime() - now.getTime();

    if (diff <= 0) {
      this.updateNextPrayer();
      return;
    }

    const jam = Math.floor(diff / (1000 * 60 * 60));
    const minit = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const saat = Math.floor((diff % (1000 * 60)) / 1000);

    this.countdown = `${jam} Jam ${minit} Minit ${saat} Saat`;
  }

  getNextPrayerTime(): Date {
    const now = new Date();
    const allTimes = Object.entries(this.prayerTime)
      .filter(([key]) => !['date', 'day', 'hijri'].includes(key))
      .map(([_, time]) => {
        const [h, m, s] = (time as string).split(':').map(Number);
        const date = new Date();
        date.setHours(h, m, s, 0);
        return date;
      })
      .filter(d => d > now);

    return allTimes.sort((a, b) => a.getTime() - b.getTime())[0];
  }

  // pad(num: number): string {
  //   return num.toString().padStart(2, '0');
  // }

  login() {
    this.router.navigate(['auth']);
  }
}
